<template>
  <div id="app">
    <HeaderPage v-if="$route.meta.showHeader" />
    <router-view />
    <FooterPage v-if="$route.meta.showFooter" />
    <button id="toTop" :class="{show: toTopShow}" @click="scrollTop"><img :src="icons.toTop" alt="返回顶部" style="width:20px;height:20px;vertical-align:middle"></button>
  </div>
</template>

<script>
import HeaderPage from './components/Header.vue'
import FooterPage from './components/Footer.vue'
import icons from '@/utils/icons'

export default {
  name: 'App',
  components: {
    HeaderPage,
    FooterPage
  },
  data() {
    return {
      icons,
      toTopShow: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
    this.onScroll()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    scrollTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    onScroll() {
      this.toTopShow = window.scrollY > 300
    }
  }
}
</script>
